import { Typography, Select } from "antd";
import React, { FC, useEffect } from "react";
import { IStatus, getStatusList } from "../helper";
import { CheckOutlined } from "@ant-design/icons";
import { StatusType } from "../../common/constants";
import { axiosInstant, endpoints } from "../../../api";

interface Props {
  id: string;
  status?: StatusType;
  onUpdate: () => void;
}

export const EditableStatus: FC<Props> = ({ id, status: initStatus, onUpdate }) => {
  // Always show these options with readable labels
  const statusOptions = getStatusList([
    StatusType.SHORTLISTED_MANAGER,
    StatusType.REJECTED_MANAGER,
  ]);

  // Set initial status from props
  const [status, setStatus] = React.useState(
    getStatusList(initStatus ? [initStatus] : undefined)[0]
  );

  // Update local status if prop changes (e.g., after refetch)
  useEffect(() => {
    setStatus(getStatusList(initStatus ? [initStatus] : undefined)[0]);
  }, [initStatus]);

  // Disable dropdown if status is final
  const isFinal = status?.value === StatusType.SHORTLISTED_MANAGER || status?.value === StatusType.REJECTED_MANAGER;

  const handleChange = async (val: IStatus) => {
    if (id) {
      await axiosInstant.patch(`/job-applications/applications/${id}/status`, { status: val.value });
      setStatus(val);
      onUpdate();
    }
  };

  return (
    <Select
      style={{ width: 140 }}
      optionLabelProp="label"
      placeholder="Select Status"
      menuItemSelectedIcon={<CheckOutlined />}
      value={status}
      labelInValue
      onChange={handleChange}
      disabled={isFinal} // <-- Disable if final status
    >
      {statusOptions.map((status) => (
        <Select.Option key={status.value} {...status}>
          {status.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default EditableStatus;
